import { CreateStripeBillingPortalRequestBody } from "@syla/shared/types/requests/CreateStripeBillingPortalRequest";
import { CreateStripeBillingPortalResponse } from "@syla/shared/types/responses/CreateStripeBillingPortalResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function createStripeBillingPortalSession(
  accountId: string,
  body: CreateStripeBillingPortalRequestBody,
): Promise<CreateStripeBillingPortalResponse> {
  try {
    const response = await axios.post<CreateStripeBillingPortalResponse>(
      `/accounts/${accountId}/subscriptions/create-stripe-billing-portal-session`,
      body,
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
